/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { WorkflowStageTaskViewModel } from './WorkflowStageTaskViewModel'; 

export function getWorkflowStageTaskOptions(workflowStageTaskId: string, onSuccess?: (result: WorkflowStageTaskViewModel) => void) {
	return queryOptions({
		queryKey: ['workflow-stage-task', workflowStageTaskId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/workflows/queries/getworkflowstagetask/' + workflowStageTaskId;
			const resp = await axios.get<WorkflowStageTaskViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(workflowStageTaskId)
	});
}